import { cn, Icon, RenderMobileCard, Table, Typography } from "@kyan/ui";

import { Krystal } from "#/components/Krystal/Krystal";
import { ReferralsDetails } from "#/types/referrals";
import { formatAddress } from "#/utils/formatAddress";

import { useReferralsController } from "./Referrals.controller";

export const Referrals = () => {
  const { referralsDetails, openCardIds, onCardClick, isLoading, columns } =
    useReferralsController();

  const renderMobileCard: RenderMobileCard<ReferralsDetails> = ({
    row,
    isOpen,
    cardId,
  }) => {
    return (
      <div
        id={cardId}
        className={cn("flex items-center justify-between p-3", {
          "bg-buttonBg": row.isYours,
        })}
      >
        <div className="flex items-center gap-1">
          <Icon size="sm" name="user" className="text-textPrimary" />
          <Typography primary size={12}>
            {formatAddress(row.address)}
          </Typography>
        </div>

        <div className="flex items-center gap-1">
          <Typography primary size={12}>
            {row.isYours ? "" : row.referralReward || "Coming soon"}
          </Typography>
          <Krystal />
          <Icon
            name="caret-down"
            className={cn(
              "text-xxs ml-1 transition-transform group-last:hidden",
              {
                "rotate-180": isOpen,
              },
            )}
          />
        </div>
      </div>
    );
  };

  return (
    <Table
      columns={columns}
      isLoading={isLoading}
      data={referralsDetails}
      openCardIds={openCardIds}
      classes={{
        table: "border-b-0",
        wrapper: "rounded-b-2xl sm:flex", // TODO: remove this when we have a proper summary table
        thead: "border-b border-divider px-8",
        row: ({ row }) => {
          return cn("border-t-0 border-b last:border-b-0 sm:px-8", {
            "bg-buttonBg": row.isYours,
          });
        },
        loading: {
          wrapper: "sm:px-8 border-t-0",
          skeleton: "h-9.5 sm:h-14 w-full sm:rounded-lg",
        },
        columnClassName: "text-textSecondary py-3.5 text-xs items-center",
        cellClassName: "text-xs text-textPrimary sm:h-15",
      }}
      onCardClick={onCardClick}
      renderMobileCard={renderMobileCard}
    />
  );
};
